import React, { memo, useState, useEffect, useMemo } from "react";
import moment from "moment";
import { getLogicalActivityDayAnchorDate } from "../general/helper";

const HorizontalDatePicker = memo(
	({ setDay, setFormattedSelectedDay, daysToShowOnMobile, guestActivityDayStartMinutes = null }) => {
	const effectiveStart = useMemo(() => {
		if (guestActivityDayStartMinutes == null) {
			return moment().startOf("day");
		}
		const anchorYmd = getLogicalActivityDayAnchorDate(
			new Date(),
			guestActivityDayStartMinutes,
		);
		return moment(anchorYmd, "YYYY-MM-DD").startOf("day");
	}, [guestActivityDayStartMinutes]);

	const numDays = daysToShowOnMobile;
	const [selectedDay, setSelectedDay] = useState(null);

	useEffect(() => {
		const anchorYmd = getLogicalActivityDayAnchorDate(
			new Date(),
			guestActivityDayStartMinutes ?? null,
		);
		const idx = moment(anchorYmd, "YYYY-MM-DD")
			.startOf("day")
			.diff(effectiveStart, "days");
		const clamped = Math.min(Math.max(0, idx), numDays - 1);
		setSelectedDay(clamped);
	}, [effectiveStart, guestActivityDayStartMinutes, numDays]);
	useEffect(() => {
		if (selectedDay !== null) {
			const selectedDate = moment(effectiveStart)
				.add(selectedDay, "days")
				.format("YYYY-MM-DD");
			setFormattedSelectedDay(selectedDate);
			const currentDate = moment(effectiveStart).add(selectedDay, "days");
			const day = currentDate.format("ddd");
			const formattedDate =
				currentDate.date() > 9 ? currentDate.format("D") : `0${currentDate.format("D")}`;
			setDay(day + " " + formattedDate);
		}
	}, [selectedDay, effectiveStart, setDay, setFormattedSelectedDay]);
	
	const renderDates = () => {
		const dates = [];
		for (let i = 0; i < numDays; i++) {
			const currentDate = moment(effectiveStart).add(i, "days");
			const day = currentDate.format("ddd");
			const isSelected = selectedDay === i;
			const dayClasses = isSelected ? "border-b-4 border-black" : "";
			const formattedDate =
				currentDate.date() > 9 ? currentDate.format("D") : `0${currentDate.format("D")}`;
			dates.push(
				<div
					key={i}
					className={`cursor-pointer h-16 flex-none w-16 flex-col justify-center items-center text-center ${dayClasses}`}
					onClick={() => handleDayClick(i)}
				>
					<div className="uppercase text-sm">{day}</div>
					<div className="font-bold text-xl">{formattedDate}</div>
				</div>
			);
		}
		return dates;
	};
	
	const handleDayClick = (index) => {
		setSelectedDay(index);
	};
	
	
	return (
		<div className="flex items-center overflow-x-auto scrollable-container">
			<div className="flex items-center justify-evenly space-x-4">
				{renderDates()}
			</div>
		</div>
	);
});

export default HorizontalDatePicker;
